import api from './api';

// Division 7A API Client
export const div7aAPI = {
  // Transaction Scanner
  scanTransactions: (transactions) => api.post('/api/div7a/scan', transactions),
  listTransactions: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.flagged_only) queryParams.append('flagged_only', 'true');
    if (params.classification) queryParams.append('classification', params.classification);
    return api.get(`/api/div7a/transactions?${queryParams.toString()}`);
  },
  classifyTransaction: (id, classification) => 
    api.patch(`/api/div7a/transactions/${id}/classify?classification=${classification}`),
  recordDecision: (id, decision) => 
    api.post(`/api/div7a/transactions/${id}/decide?decision=${decision}`),
  
  // Loan Management
  listLoans: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.status) queryParams.append('status_filter', params.status);
    return api.get(`/api/div7a/loans?${queryParams.toString()}`);
  },
  createLoan: (data) => api.post('/api/div7a/loans', data),
  getLoan: (id) => api.get(`/api/div7a/loans/${id}`),
  getLoanMYRSchedule: (id) => api.get(`/api/div7a/loans/${id}/myr-schedule`),
  
  // Repayment Tracking
  createRepayment: (data) => api.post('/api/div7a/repayments', data),
  
  // Dashboard & Compliance
  getDashboardMetrics: () => api.get('/api/div7a/dashboard/metrics')
};